import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";

export const PhaseTemplateCard = ({
  template,
  index,
  selectedPhaseIndex,
  setSelectedPhaseIndex,
}) => {
  const { t } = useTranslation("coaching-portal");
  const { _id, templateName, phases } = template;

  // Phases predate the `track` field - anything without one was always
  // training (see msb-api/lib/schemas/user.js), so it defaults there too.
  const trainingPhases = phases.filter(
    (phase) => (phase.track || "training") === "training"
  );
  const nutritionPhases = phases.filter((phase) => phase.track === "nutrition");
  const openEditTemplateModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        templateId: _id,
        "modal[type]": "edit-template",
      },
    });
  };

  const openRemoveTemplateModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        templateId: _id,
        "modal[type]": "remove-template",
        templateToRemove: template,
      },
    });
  };

  const renderPhaseList = (list, track) => (
    <div className="phase-template-phases">
      {list.map((phase, phaseIndex) => (
        <div
          className="phase-template-phase"
          key={`temp-phase-card-${track}-${phaseIndex}`}
        >
          <div
            style={{
              backgroundColor: phase.phaseColor,
            }}
            className="phase-color-dot"
          />
          <span className="phase-name">{phase.phaseName}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div
      className={`phase-template-card${
        selectedPhaseIndex === index ? " active" : ""
      }`}
      onClick={() => setSelectedPhaseIndex(index)}
    >
      <div className="phase-info-wrapper">
        <div role="card-selector">
          {selectedPhaseIndex === index ? (
            <img src={"/img/new-icons/vuesax-linear-tick-no-background.svg"} />
          ) : null}
        </div>
        <span className="phase-template-name">{templateName}</span>
        {trainingPhases.length ? (
          <>
            <hr className="phase-template-divider" />
            <div className="phase-track-section">
              <span className="phase-track-title">
                {t("phaseTracks.training")}
              </span>
              {renderPhaseList(trainingPhases, "training")}
            </div>
          </>
        ) : null}
        {nutritionPhases.length ? (
          <>
            <hr className="phase-template-divider" />
            <div className="phase-track-section">
              <span className="phase-track-title">
                {t("phaseTracks.nutrition")}
              </span>
              {renderPhaseList(nutritionPhases, "nutrition")}
            </div>
          </>
        ) : null}
      </div>
      <hr className="phase-template-divider" />
      <div className="phase-template-card-footer">
        <button data-button-type="secondary" onClick={openEditTemplateModal}>
          {t("phaseTemplateCard.editTemplate")}
        </button>
        <picture role="button" data-button-type="secondary">
          <img
            src="/img/new-icons/red-trash.svg"
            onClick={openRemoveTemplateModal}
          />
        </picture>
      </div>
    </div>
  );
};
